module.exports = __webpack_public_path__ + "static/media/Basketball.1b7dd3f2.jpg";